import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { ClientTeamList } from "@components/organizationView/clients/TeamList/ClientTeamList";
import type { ApplyCoaTemplateEntitySelectionRow } from "../applyCoaTemplateEntitySelection.types";

export const ApplyCoaEntityTeamCell = memo(
    ({
        row,
    }: CellContext<
        ViewTableFeatures,
        ApplyCoaTemplateEntitySelectionRow,
        unknown
    >) => {
        if (row.original.isClientRow) {
            return <ViewTableCell />;
        }

        const { team } = row.original;
        if (team.length === 0) {
            return <ViewTableCell />;
        }

        return (
            <ViewTableCell>
                <ClientTeamList members={team} iconSize="sm" hideRole />
            </ViewTableCell>
        );
    },
);
